import { autoinject, useView } from "aurelia-framework";
import { DocumentManagementService } from "../../../../../services/document-management.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DocumentManagementDialogConstants } from "../../../../../constants/dialog.constants";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";

@autoinject
@useView('@rightship-tech/document-management-app/views/dialogs/manage-access-share-outcome/tabs/permissions/permissions.html')
export class Permissions {
    public emails: string[] = [];
    private _rightshipInspectionId: number;
    public removedEmails: string[] = [];
    private subscription: Subscription;
    public loadAccess: () => Promise<void>;
    public refreshEmails: (emails: string[]) => void;

    constructor(private documentManagementService: DocumentManagementService,
        private dialogClientService: DialogClientService,
        private notificationClientService: NotificationClientService, private eventAggregator: EventAggregator
    ) {
    }

    activate(params: { emails: string[], rightshipInspectionId: number, loadAccess: () => Promise<void>, refreshEmails: (emails: string[]) => void; }) {
        this.emails = params.emails;
        this._rightshipInspectionId = params.rightshipInspectionId;
        this.loadAccess = params.loadAccess;
        this.refreshEmails = params.refreshEmails;
    }

    attached() {
        this.subscription = this.eventAggregator.subscribe("emails-changed", x => {
            if (x.emails){
                this.emails = x.emails;
            }
        });
    }

    detached(): void {
        if (this.subscription) {
            this.subscription.dispose();
        }
    }

    openShareDialog() {
        this.dialogClientService.show(DocumentManagementDialogConstants.ShareOutcomDialog, { 
            rightshipInspectionId: this._rightshipInspectionId,
            refreshEmails: this.refreshEmails.bind(this),
            onClose: () => {
                if(this.loadAccess) this.loadAccess();
            }
        }, true, false, false, "right");
    }

    async resendEmail(email: string) {
        try {
            await this.documentManagementService.shareRightshipInspectionDocumentAccess(this._rightshipInspectionId, [email], true, null);

            this.notificationClientService.show("Resend successfully", "", NotificationType.Success);
        }
        catch (error) {
            this.notificationClientService.show("Error when resend the email", "", NotificationType.Error);
        }
       
    }

    removeEmail(email: string) {
        this.dialogClientService.show(DocumentManagementDialogConstants.RemoveAccessDialog, {
            emails: [email],
            rightshipInspectionId: this._rightshipInspectionId,
            onSave: () => { 
                this.emails = this.emails.filter(x => x !== email); 
                if(this.refreshEmails) this.refreshEmails(this.emails);
            },
        }, true, false, false);
    }
}
